import AxisChart from './AxisChart';

export default AxisChart;
